import nav from "./components/nav_it.json";
import movement_table from "./components/movement_table_it.json";
import staging_timeline from "./components/staging_timeline_it.json";
import bolton from "./components/bolton_it.json";
import overjet_overbite from "./components/overjet_overbite_it.json";
import controls from "./components/controls_it.json";
import others from "./components/others_it.json";
export const it = {
  nav: { ...nav },
  movement_table: { ...movement_table },
  staging_timeline: { ...staging_timeline },
  bolton: { ...bolton },
  overjet_overbite: { ...overjet_overbite },
  controls: { ...controls },
  other: { ...others },
};
